import { ModeType } from '../enums/ModeType.enum';

export const DEFAULT_MODE_TYPE_NOT_AUTHENTICATED = ModeType.Grid;
export const DEFAULT_MODE_TYPE_MOBILE = ModeType.List;
export const DEFAULT_MODE_TYPE_DESKTOP = ModeType.MinifyList;
